/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useMemo } from "react";
import { Table, Button, Tab, Tabs, Placeholder, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import InvoiceDetailsModal from "./_invoice_details_modal";

export default function TenantInvoices({ invoices, isLoading }) {
    const [currentPage, setCurrentPage] = useState(0);
    const [activeTab, setActiveTab] = useState("kra_quarterly");
    const [searchTerm, setSearchTerm] = useState("");
    const itemsPerPage = 10;
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [showModal, setShowModal] = useState(false);

    // Filter data based on the active tab
    const tabData = (() => {
        switch (activeTab) {
            case "kra_monthly":
                return invoices?.kra_monthly || [];
            case "kra_quarterly":
                return invoices?.kra_quartely || [];
            case "non_kra_monthly":
                return invoices?.non_kra_monthly || [];
            case "non_kra_quarterly":
                return invoices?.non_kra_quartely || [];
            default:
                return [];
        }
    })();

    // Filter data based on search term
    const filteredData = useMemo(() => {
        if (!searchTerm) return tabData;

        const term = searchTerm.toLowerCase();
        return tabData.filter(item =>
            item.unit?.toLowerCase().includes(term) ||
            item.tenant_name?.toLowerCase().includes(term) ||
            item.tenant_phone?.toLowerCase().includes(term) ||
            item.kra_pin?.toLowerCase().includes(term) ||
            item.tax_amount?.toString().includes(term) ||
            item.rent_amount?.toString().includes(term) ||
            item.total_amount?.toString().includes(term)
        );
    }, [tabData, searchTerm]);

    const totalPages = Math.ceil(filteredData.length / itemsPerPage) || 1;
    const startIndex = currentPage * itemsPerPage;
    const endIndex = Math.min(startIndex + itemsPerPage, filteredData.length);
    const displayedItems = filteredData.slice(startIndex, endIndex);

    const handlePrevPage = () => {
        if (currentPage > 0) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages - 1) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handleViewDetails = (invoice) => {
        setSelectedInvoice({
            ...invoice,
            type: activeTab.includes('quarterly') ? 'quarterly' : 'monthly'
        });
        setShowModal(true);
        console.log(activeTab)
    };
    console.log(" KRA invoice for:", selectedInvoice);

    const handleKraInvoice = () => {
        console.log("Generating KRA invoice for:", selectedInvoice);
        // Add your KRA invoice generation logic here
    };

    const handleTabChange = (key) => {
        setActiveTab(key);
        setCurrentPage(0);
        setSearchTerm(""); // Reset search term when changing tabs
    };

    return (
        <div className="shadow-lg mt-0 tasks">
            <div className="d-flex align-items-center justify-content-between mb-3">
                <h5 className="mb-0">List of Tenants</h5>
                <Form.Group controlId="search" className="mb-0" style={{ width: '300px' }}>
                    <Form.Control
                        type="text"
                        placeholder="Search"
                        value={searchTerm}
                        onChange={(e) => {
                            setSearchTerm(e.target.value);
                            setCurrentPage(0); // Reset to first page when searching
                        }}
                    />
                </Form.Group>
            </div>

            {/* Tabs for filtering */}
            <Tabs
                activeKey={activeTab}
                onSelect={handleTabChange}
                className="mb-3"
            >
                <Tab
                    eventKey="kra_quarterly"
                    title={
                        <span className={`p-2 ${activeTab === "kra_quarterly" ? "bg-primary text-white" : "bg-transparent text-dark"}`}>
                            Category A
                        </span>
                    }
                />
                <Tab
                    eventKey="kra_monthly"
                    title={
                        <span className={`p-2 ${activeTab === "kra_monthly" ? "bg-primary text-white" : "bg-transparent text-dark"}`}>
                            Category B
                        </span>
                    }
                />

                <Tab
                    eventKey="non_kra_monthly"
                    title={
                        <span className={`p-2 ${activeTab === "non_kra_monthly" ? "bg-primary text-white" : "bg-transparent text-dark"}`}>
                            Category C
                        </span>
                    }
                />
                {/* <Tab
                    eventKey="non_kra_quarterly"
                    title={
                        <span className={`p-2 ${activeTab === "non_kra_quarterly" ? "bg-primary text-white" : "bg-transparent text-dark"}`}>
                            Non-KRA Quarterly
                        </span>
                    }
                /> */}
            </Tabs>

            {/* Table */}
            <Table className="">
                <thead>
                    <tr>
                        <th>Unit No.</th>
                        <th>Tenant Name</th>
                        <th>Tenant Phone</th>
                        <th>KRA Pin No.</th>
                        <th>Tax Amount</th>
                        <th>Rent Amount</th>
                        <th>Previous Balance</th>
                        <th>Total Amount</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {isLoading ? (
                        // Skeleton loading state
                        Array.from({ length: 5 }).map((_, index) => (
                            <tr key={`skeleton-${index}`}>
                                <td><Placeholder animation="glow"><Placeholder xs={6} /></Placeholder></td>
                                <td><Placeholder animation="glow"><Placeholder xs={8} /></Placeholder></td>
                                <td><Placeholder animation="glow"><Placeholder xs={10} /></Placeholder></td>
                                <td><Placeholder animation="glow"><Placeholder xs={6} /></Placeholder></td>
                                <td><Placeholder animation="glow"><Placeholder xs={6} /></Placeholder></td>
                                <td><Placeholder animation="glow"><Placeholder xs={6} /></Placeholder></td>
                                <td><Placeholder animation="glow"><Placeholder xs={6} /></Placeholder></td>
                                <td><Placeholder animation="glow"><Placeholder xs={6} /></Placeholder></td>
                                <td>
                                    <Placeholder.Button animation="glow" variant="warning" xs={4} className="ms-2" />
                                </td>
                            </tr>
                        ))
                    ) : filteredData.length === 0 ? (
                        <tr>
                            <td colSpan={8} className="text-center">
                                {searchTerm ? "No matching tenants found" : "No tenants found"}
                            </td>
                        </tr>
                    ) : (
                        displayedItems.map((invoice) => (
                            <tr key={`${invoice.unit_id}-${invoice.tenant_phone}`}>
                                <td>{invoice.unit}</td>
                                <td>{invoice.tenant_name}</td>
                                <td>{invoice.tenant_phone}</td>
                                <td>{invoice.kra_pin || "N/A"}</td>
                                <td>Ksh. {invoice.tax_amount?.toLocaleString() || "0"}</td>
                                <td>Ksh. {invoice.rent_amount?.toLocaleString()}</td>
                                <td>Ksh. {invoice.opening_balance?.toLocaleString()}</td>
                                <td>Ksh. {invoice.total_amount?.toLocaleString()}</td>
                                <td className="d-flex justify-content-between">
                                    <Button variant="warning" size="sm" className="text-white" onClick={() => handleViewDetails(invoice)}>View Details</Button>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </Table>

            {/* Pagination */}
            {!isLoading && filteredData.length > 0 && (
                <div className="d-flex align-items-center justify-content-between mt-3">
                    <Button
                        variant="outline-primary"
                        onClick={handlePrevPage}
                        disabled={currentPage === 0}
                    >
                        Previous
                    </Button>
                    <span>
                        Showing {startIndex + 1}-{endIndex} of {filteredData.length}
                    </span>
                    <Button
                        variant="outline-primary"
                        onClick={handleNextPage}
                        disabled={currentPage >= totalPages - 1}
                    >
                        Next
                    </Button>
                </div>
            )}
            <InvoiceDetailsModal
                show={showModal}
                handleClose={() => setShowModal(false)}
                invoice={selectedInvoice}
                handleKraInvoice={handleKraInvoice}
            />
        </div>
    );
}